<template>
  <div id="pageEquipamiento" @click="handleClickOutside">
    <v-container fluid>
      <v-row>
        <v-col>
          <v-card class="equipamiento-card elevation-2">
            <!-- Header mejorado -->
            <v-toolbar color="primary" dark flat>
              <v-icon class="mr-2">mdi-tools</v-icon>
              <v-toolbar-title v-if="!$vuetify.breakpoint.mdAndDown">Lista de equipamiento</v-toolbar-title>
              <v-spacer></v-spacer>
              <!-- Búsqueda para escritorio -->
              <v-col cols="3" class="mr-3" v-if="!$vuetify.breakpoint.mdAndDown">
                <v-text-field
                  v-model="filter.search"
                  label="Buscar equipamiento..."
                  prepend-inner-icon="mdi-magnify"
                  hide-details
                  clearable
                  rounded
                  single-line
                  filled
                  dense
                  dark
                ></v-text-field>
              </v-col>
              <!-- Búsqueda para móvil -->
              <v-tooltip top v-if="$vuetify.breakpoint.mdAndDown && !showSearch">
                <template v-slot:activator="{ on }">
                  <v-btn icon v-on="on" @click.stop="toggleSearch">
                    <v-icon>mdi-magnify</v-icon>
                  </v-btn>
                </template>
                <span>Buscar</span>
              </v-tooltip>
              <v-col cols="12" v-if="showSearch && $vuetify.breakpoint.mdAndDown">
                <v-text-field
                  ref="searchInput"
                  v-model="filter.search"
                  label="Buscar equipamiento..."
                  prepend-inner-icon="mdi-magnify"
                  hide-details
                  clearable
                  rounded
                  single-line
                  filled
                  dense
                  dark
                  @keydown.esc="showSearch = false"
                ></v-text-field>
              </v-col>

              <!-- Menú de filtros mejorado -->
              <filter-menu
                title="Filtrar equipamiento"
                :current-filter="currentFilter"
                @canceled="rollbackFilter()"
                @filtered="commitFilter()"
              >
                <v-col dense>
                  <v-row cols="12">
                    <v-text-field
                      v-model="filter.name"
                      label="Nombre del equipamiento"
                      clearable
                      outlined
                      dense
                      hide-details="auto"
                      class="mb-4"
                      prepend-inner-icon="mdi-tools"
                    ></v-text-field>
                  </v-row>
                </v-col>
              </filter-menu>              <!-- Botón para agregar equipamiento -->
              <v-tooltip top v-if="canManageEquipamiento">
                <template v-slot:activator="{ on }">
                  <v-btn icon v-on="on" @click="showEquipamientoForm(null)" class="mr-2" color="white">
                    <v-icon>mdi-plus</v-icon>
                  </v-btn>
                </template>
                <span>Agregar Equipamiento</span>
              </v-tooltip>
              <!-- Botón para refrescar -->
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn icon @click="refreshDataTable" v-on="on" color="white" class="mr-0">
                    <v-icon>mdi-refresh</v-icon>
                  </v-btn>
                </template>
                <span>Actualizar lista</span>
              </v-tooltip>
              <!-- Formulario de equipamiento (modal) -->
              <equipamiento-form
                v-if="visibleForm"
                v-model="editItem"
                @save="updateDataTable"
                @cancel="visibleForm = false"
              ></equipamiento-form>
            </v-toolbar>
            <!-- Selector de vista (tarjetas/tabla) -->
            <v-card-actions class="px-4 py-2">
              <div class="text-subtitle-1 font-weight-medium grey--text text--darken-2">
                {{ totalItems }} equipamientos encontrados
              </div>
              <v-spacer></v-spacer>
              <v-btn-toggle
                v-model="viewMode"
                mandatory
                dense
                color="primary"
              >
                <v-btn value="cards" small>
                  <v-icon small>mdi-view-grid-outline</v-icon>
                  Tarjetas
                </v-btn>
                <v-btn value="table" small>
                  <v-icon small>mdi-table</v-icon>
                  Tabla
                </v-btn>
              </v-btn-toggle>
            </v-card-actions>
            <!-- Vista de tarjetas -->
            <v-card-text v-if="viewMode === 'cards'" class="px-4 pt-0 pb-4">
              <!-- Estado de carga -->
              <v-row v-if="loadingItems">
                <v-col cols="12" sm="6" md="4" lg="3" v-for="n in 8" :key="`skeleton-${n}`">
                  <v-skeleton-loader type="card" class="mb-4"></v-skeleton-loader>
                </v-col>
              </v-row>              <!-- Estado sin resultados -->
              <v-row v-else-if="!EQUIPAMIENTOS.length" class="text-center py-5">
                <v-col cols="12">
                  <h3 class="text-h5 grey--text text--darken-1 mb-2">No se encontraron equipamientos</h3>
                  <p class="text-subtitle-1 grey--text mb-6">Intenta cambiar los filtros o añade un nuevo equipamiento</p>
                  <v-btn v-if="canManageEquipamiento" color="primary" outlined @click="showEquipamientoForm(null)">
                    <v-icon left>mdi-plus</v-icon>
                    Agregar equipamiento
                  </v-btn>
                </v-col>
              </v-row>
              <!-- Lista de equipamientos en tarjetas -->
              <v-row v-else>
                <v-col cols="12" sm="6" md="4" lg="3" v-for="equipamiento in EQUIPAMIENTOS" :key="equipamiento.id">
                  <v-card
                    class="equipamiento-card-item h-100"
                    outlined
                    hover
                    @click="viewEquipamientoDetails(equipamiento)"
                  >
                  <v-card-text class="pa-4">
                    <!-- Avatar y estado -->
                    <div class="d-flex mb-4">
                      <v-avatar size="56" color="primary lighten-4" class="mr-3">
                        <v-icon size="32" color="primary">mdi-tools</v-icon>
                      </v-avatar>
                      <div>
                        <div class="subtitle-1 font-weight-bold mb-1">
                          {{ equipamiento.name }}
                        </div>
                      </div>
                    </div>
                    <!-- Información básica -->
                    <v-list dense class="pa-0 transparent">
                      <v-list-item class="px-0">
                        <v-list-item-icon class="mr-2">
                          <v-icon small color="grey darken-1">mdi-car-multiple</v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                          <v-list-item-subtitle>
                            <div v-if="equipamiento.assigned_vehicle_types && equipamiento.assigned_vehicle_types.length > 0">
                              <v-chip 
                                v-for="type in equipamiento.assigned_vehicle_types" 
                                :key="type.vehicle_type" 
                                x-small 
                                outlined 
                                color="primary"
                                class="mr-1 mb-1"
                              >
                                {{ type.vehicle_type_label }}
                              </v-chip>
                              <div class="caption grey--text mt-1">
                                {{ getVehicleTypeCount(equipamiento) }} tipo{{ getVehicleTypeCount(equipamiento) !== 1 ? 's' : '' }} asignado{{ getVehicleTypeCount(equipamiento) !== 1 ? 's' : '' }}
                              </div>
                            </div>
                            <span v-else class="grey--text">Sin tipos asignados</span>
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-card-text>
                    <v-divider></v-divider>                    <!-- Acciones de tarjeta -->
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn v-if="canManageEquipamiento" icon small color="primary" @click.stop="showEquipamientoForm(equipamiento)" title="Editar">
                        <v-icon>mdi-pencil</v-icon>
                      </v-btn>
                      <v-btn
                        v-if="canManageEquipamiento"
                        icon
                        small
                        color="red"
                        @click.stop="confirmDeleteEquipamiento(equipamiento)"
                        title="Eliminar"
                      >
                        <v-icon>mdi-delete</v-icon>
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-col>
              </v-row>
              <!-- Paginación en vista de tarjetas -->
              <div class="text-center pt-4" v-if="!loadingItems && EQUIPAMIENTOS.length > 0">
                <v-row>
                  <v-col cols="12" class="d-flex justify-center align-center flex-wrap pa-2">
                    <div class="text-center d-flex align-center mr-4">
                      <span class="text-body-2 grey--text text--darken-1">Filas por página:</span>
                      <v-select v-model="pagination.itemsPerPage" :items="footer.itemsPerPageOptions" dense outlined
                        hide-details class="ml-2" style="width: 80px;" @change="onItemsPerPageChange"></v-select>
                    </div>

                    <v-pagination v-model="pagination.page" :length="Math.ceil(totalItems / pagination.itemsPerPage)"
                      :total-visible="7" circle @input="onPageChange"></v-pagination>

                    <span class="text-body-2 grey--text text--darken-1 ml-4">
                      {{ paginationText }}
                    </span>
                  </v-col>
                </v-row>
              </div>
            </v-card-text>
            <!-- Vista de tabla -->
            <v-card-text v-else class="pa-0">
              <v-data-table
                :headers="headers"
                :items="EQUIPAMIENTOS"
                :options.sync="pagination"
                :loading="loadingItems"
                :footer-props="footer"
                :key="tableId"
                item-key="id"
                class="elevation-0"
                multi-sort
                @click:row="viewEquipamientoDetails"
                :server-items-length="totalItems"
              >
                <!-- Columna de nombre -->
                <template v-slot:item.name="{ item }">
                  <div class="d-flex align-center">
                    <v-avatar size="36" color="primary lighten-4" class="mr-2">
                      <v-icon size="20" color="primary">mdi-tools</v-icon>
                    </v-avatar>
                    <div>
                      <div class="font-weight-medium">{{ item.name }}</div>
                    </div>
                  </div>
                </template>
                <!-- Columna de tipos de vehículos -->
                <template v-slot:item.vehicle_types="{ item }">
                  <div>
                    <div v-if="item.assigned_vehicle_types && item.assigned_vehicle_types.length > 0">
                      <v-chip 
                        v-for="type in item.assigned_vehicle_types" 
                        :key="type.vehicle_type" 
                        small 
                        outlined 
                        color="primary"
                        class="mr-1 mb-1"
                      >
                        {{ type.vehicle_type_label }}
                      </v-chip>
                    </div>
                    <div v-else>
                      <span class="grey--text text--darken-1">Sin tipos asignados</span>
                      <div class="caption grey--text text--darken-1" v-if="item.available_vehicle_types">
                        {{ Object.keys(item.available_vehicle_types).length }} tipos disponibles
                      </div>
                    </div>
                  </div>
                </template>
                
                <!-- Columna de dealer (solo para colaboradores) -->
                <!-- <template v-slot:item.dealer="{ item }">
                  <div class="d-flex align-center">
                    <v-avatar size="24" class="mr-2" v-if="item.dealership">
                      <img v-if="item.dealership.imageUrl && item.dealership.imageUrl.url" 
                           :src="item.dealership.imageUrl.url" 
                           alt="Logo del dealer">
                      <v-icon v-else size="16" :color="item.dealership.is_own ? 'primary' : 'grey'">
                        {{ item.dealership.is_own ? 'mdi-home' : 'mdi-store' }}
                      </v-icon>
                    </v-avatar>
                    <div v-if="item.dealership">
                      <div class="font-weight-medium">{{ item.dealership.name }}</div>
                      <div class="caption grey--text text--darken-1">{{ item.dealership.city }}</div>
                    </div>
                    <div v-else class="grey--text">N/A</div>
                  </div>
                </template> -->
                
                <!-- Columna de acciones -->
                <template v-slot:item.action="{ item }">
                  <div class="d-inline-flex action-buttons">                    
                    <v-tooltip top v-if="canManageEquipamiento">
                      <template v-slot:activator="{ on }">
                        <v-btn
                          icon
                          small
                          color="primary"
                          @click.stop="showEquipamientoForm(item)"
                          v-on="on"
                        >
                          <v-icon>mdi-pencil</v-icon>
                        </v-btn>
                      </template>
                      <span>Editar</span>
                    </v-tooltip>
                    <v-tooltip top v-if="canManageEquipamiento">
                      <template v-slot:activator="{ on }">
                        <v-btn
                          icon
                          small
                          color="red"
                          @click.stop="confirmDeleteEquipamiento(item)"
                          v-on="on"
                        >
                          <v-icon>mdi-delete</v-icon>
                        </v-btn>
                      </template>
                      <span>Eliminar</span>
                    </v-tooltip>
                  </div>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <!-- Diálogo de confirmación mejorado -->
    <v-dialog v-model="dialogDelete" max-width="500px">
      <v-card>
        <v-card-title class="headline error--text">Confirmar eliminación</v-card-title>
        <v-card-text class="py-4">
          <v-row>
            <v-col cols="auto" class="pr-0">
              <v-avatar color="error" size="48" class="mr-4">
                <v-icon dark>mdi-alert</v-icon>
              </v-avatar>
            </v-col>
            <v-col>
              <p class="mb-1">¿Estás seguro de que deseas eliminar este equipamiento?</p>
              <p class="subtitle-1 font-weight-medium">{{ selectedEquipamiento.name }}</p>
            </v-col>
          </v-row>
          <p class="caption mt-3 red--text">Esta acción no se puede deshacer.</p>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="dialogDelete = false">Cancelar</v-btn>
          <v-btn color="error" text @click="deleteEquipamiento" :loading="loadingDelete">Eliminar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import _ from 'lodash'
import { mapGetters } from 'vuex'
import FilterMenu from '../../components/FilterMenu'
export default {
  components: {
    FilterMenu,
    EquipamientoForm: () => import(/* webpackPrefetch: true */ './EquipamientoForm')
  },

  data: () => ({
    // Vista y carga
    loadingItems: false,
    loadingDelete: false,
    totalItems: 0,
    tableId: 0,
    showSearch: false,
    
    manualViewMode: null,
    // Tabla
    headers: [
      {
        text: 'Nombre',
        value: 'name',
        sortable: true,
        width: '40%'
      },
      {
        text: 'Tipos de vehículos',
        value: 'vehicle_types',
        sortable: false,
        width: '40%'
      },
      {
        text: 'Acciones',
        value: 'action',
        sortable: false,
        align: 'center',
        width: '20%'
      }
    ],
    footer: {
      itemsPerPageOptions: [10, 20, 30, 40, 50],
      itemsPerPageText: 'equipamientos por página:',
      pageText: '{0}-{1} de {2}'
    },

    // Filtro
    filter: {
      search: null,
      name: null
    },
    currentFilter: {
      search: null,
      name: null
    },
    // Formulario
    visibleForm: false,
    editItem: null,
    // Diálogo de confirmación
    dialogDelete: false,
    selectedEquipamiento: {}

  }),
  computed: {
    ...mapGetters(['CURRENT_USER_ROLES']),
    ...mapGetters({
      EQUIPAMIENTOS: 'EQUIPAMIENTOS',
      EQUIPAMIENTOS_PAG: 'EQUIPAMIENTOS_PAG'
    }),
    viewMode: {
      get() {
        // Si el usuario cambió manualmente la vista, usar esa
        if (this.manualViewMode) {
          return this.manualViewMode
        }
        // Detectar dispositivo y retornar vista por defecto
        if (this.$vuetify && this.$vuetify.breakpoint && this.$vuetify.breakpoint.mdAndUp) {
          return 'table'
        }
        return 'cards'
      },
      set(value) {
        // Permitir cambio manual de vista
        this.manualViewMode = value
      }
    },
    
    pagination: {
      get: function () {
        return this.EQUIPAMIENTOS_PAG
      },
      set: function (value) {
        this.$store.commit('SET_EQUIPAMIENTOS_PAG', value)
      }
    },
    paginationText () {
      const start = (this.pagination.page - 1) * this.pagination.itemsPerPage + 1
      const end = Math.min(start + this.pagination.itemsPerPage - 1, this.totalItems)
      return `${start}-${end} de ${this.totalItems}`
    },
    searchTerm () {
      return this.filter.search
    },
    totalPages () {
      return Math.ceil(this.totalItems / this.pagination.itemsPerPage)
    },
    canManageEquipamiento () {
      return !this.CURRENT_USER_ROLES.includes('mechanic')
    }
  },

  methods: {
    loadData () {
      this.loadingItems = true
      
      // Preparar parámetros de filtro
      let filterParams = { ...this.filter }
      
      this.$store.dispatch('LOAD_EQUIPAMIENTOS', filterParams).then(result => {
        this.totalItems = result || 0
        // Asegurarse de que la página actual es válida
        const maxPage = Math.ceil((result || 0) / this.pagination.itemsPerPage)
        if (this.pagination.page > maxPage && maxPage > 0) {
          this.pagination.page = maxPage
        }
        this.loadingItems = false
      }).catch(error => {
        console.error('Error al cargar equipamientos:', error)
        this.$toast.error('Error al cargar equipamientos')
        this.loadingItems = false
        this.totalItems = 0
      })
    },

    debouncedLoadData: _.debounce(function () {
      this.loadData()
    }, 500),
    updateDataTable ({ insert }) {
      this.visibleForm = false
      if (insert) {
        this.totalItems++
      }
      this.refreshDataTable()
      this.$toast.success(insert ? 'Equipamiento creado con éxito' : 'Equipamiento actualizado con éxito')
    },
    refreshDataTable () {
      this.tableId++
      this.loadData()
    },

    // Filtros
    commitFilter () {
      for (const key in this.currentFilter) {
        this.currentFilter[key] = this.filter[key]
      }
      this.loadData()
    },
    rollbackFilter () {
      for (const key in this.currentFilter) {
        this.filter[key] = this.currentFilter[key]
      }
    },

    // Acciones
    showEquipamientoForm (item) {
      this.editItem = item ? { ...item } : null
      this.visibleForm = true
    },
    viewEquipamientoDetails (equipamiento) {
      // Por ahora solo log, luego se puede implementar vista de detalles
    },
    toggleSearch () {
      this.showSearch = !this.showSearch
      if (this.showSearch) {
        this.$nextTick(() => {
          this.$refs.searchInput.focus()
        })
      }
    },
    handleClickOutside (event) {
      const searchInput = this.$refs.searchInput
      if (searchInput && !searchInput.$el.contains(event.target)) {
        this.showSearch = false
      }
    },
    deleteEquipamiento () {
      this.loadingDelete = true
      this.$store.dispatch('DELETE_EQUIPAMIENTO', this.selectedEquipamiento).then(() => {
        this.dialogDelete = false
        this.loadingDelete = false
        this.$toast.success('Equipamiento eliminado con éxito')
        this.refreshDataTable()
      }).catch(error => {
        console.error('Error al eliminar equipamiento:', error)
        this.$toast.error('Error al eliminar equipamiento')
        this.loadingDelete = false
      })
    },
    confirmDeleteEquipamiento (item) {
      this.selectedEquipamiento = item
      this.dialogDelete = true
    },
    // Utilidades
    getVehicleTypesText (assignedTypes) {
      if (!assignedTypes || !Array.isArray(assignedTypes) || assignedTypes.length === 0) {
        return 'Sin tipos asignados'
      }
      return assignedTypes.map(type => type.vehicle_type_label || type.label || type).join(', ')
    },
    getVehicleTypeCount (equipamiento) {
      if (!equipamiento.assigned_vehicle_types || !Array.isArray(equipamiento.assigned_vehicle_types)) {
        return 0
      }
      return equipamiento.assigned_vehicle_types.length
    },
    onPageChange (page) {
      // Actualizar la página en la paginación
      this.pagination.page = page
      // Forzar la carga de datos inmediatamente después del cambio de página
      this.loadData()
    },
    onItemsPerPageChange (perPage) {
      // Actualizar items por página en la paginación
      this.pagination.itemsPerPage = perPage
      // Asegurarse de volver a la primera página al cambiar elementos por página
      this.pagination.page = 1
      // Forzar la carga de datos
      this.loadData()
    }
  },
  watch: {
    pagination: {
      handler (newVal, oldVal) {
        // Verificar si realmente cambió algo importante que requiera recargar
        const relevantPropsChanged = ['page', 'itemsPerPage', 'sortBy', 'sortDesc'].some(
          prop => !_.isEqual(newVal[prop], oldVal?.[prop])
        )
        // Solo recargar si hay cambios relevantes y no estamos en medio de una carga
        if (relevantPropsChanged && !this.loadingItems && !this.isInitializing) {
          this.loadData()
        }
      },
      deep: true
    },
    searchTerm () {
      this.debouncedLoadData()
    },
    manualViewMode (newVal, oldVal) {
      // Incrementar tableId cuando cambiamos a vista de tabla para forzar re-renderizado
      if (newVal === 'table' && oldVal === 'cards') {
        this.$nextTick(() => {
          this.tableId++
          setTimeout(() => {}, 100)
        })
      }
    }
  },
  created () {
    // Bandera para evitar recarga durante la inicialización
    this.isInitializing = true
    
    this.loadData()
    // Desactivar la bandera de inicialización después de la carga inicial
    this.$nextTick(() => {
      this.isInitializing = false
    })
  }
}
</script>

<style scoped>
.equipamiento-card {
  border-radius: 8px;
  overflow: hidden;
}

.equipamiento-card-item {
  transition: box-shadow 0.2s ease-in-out, transform 0.2s ease;
}

.equipamiento-card-item:hover {
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.1) !important;
  transform: translateY(-2px);
}

.action-buttons button {
  opacity: 0.7;
  transition: opacity 0.2s ease;
}

.action-buttons button:hover {
  opacity: 1;
}

.search-input-mobile {
  max-width: 200px;
}

/* Animación para nuevos elementos */
@keyframes highlight {
  0% {
    background-color: rgba(var(--v-primary-base), 0.1);
  }
  100% {
    background-color: transparent;
  }
}

.new-item {
  animation: highlight 2s ease-in-out;
}
</style>
